// import './jquery.ztree.all-3.5'
// redirect 重定向 后加
import store from '../../../src/store/index'
var desingVm
var panelselection = function (vm) {
  desingVm = vm
  var indicator = ''
  if(vm.$route.path == '/Index/booklets/reportManage'){
    indicator = '/api/customizeReport/getRegimeType?displayCommonIndicators=0&searchType=2' //出表指标接口
  }else{
    indicator = `/api/templets/muiltindicator?report_code=${store.state.report_code}`//入表指标接口
  }
  this.config = {
    id: "panel",
    isPopWindow: false,
    isInitReset: true,
    isMultiBtn: true,
    isExcelBtn: false,
    isSelectReturnData: true,
    isReturnAllData: true,
    isValidateSelect: [0, 0, 0, 0],
    options: [{
        show: '指标',
        name: 'indicator',
        redirect: ''
      },
      {
        show: '分组',
        name: 'group',
        redirect: ''
      },
      {
        show: '地区',
        name: 'area',
        redirect: ''
      },
      {
        show: '对比项',
        name: 'contrast',
        redirect: ''
      },
      {
        show: '指标解释',
        name: 'indExplain',
        redirect: ''
      }
    ],
    urls: {
      //indicator: `/api/templets/muiltindicator?report_code=${store.state.report_code}`,
      indicator: indicator,
      group: '/api/templets/muiltgroup',
      area: '/api/templets/muiltarea',
      contrast: '/api/templets/muiltcalc'
    }
  };
  this.cache = {
    jsonData: [], //json子数据 用于搜索
    jsonList: null, //json全数据
    clicks: 0, //点击次数
    mouseupTimer: null //setTimeout全局变量
  };
};
panelselection.prototype = {
  /**
   * 整个程序初始化的执行入口
   * @param {Object} customConfig
   */
  init: function (customConfig) {
    this.config = $.extend(this.config, customConfig || {});
  },
  /**
   * 弹出层居中显示
   */
  showLoadingStatus: function () {
    var mask = document.getElementById("selection-mask");
    var $main = $(".selection-main");
    var top = $(document).scrollTop();
    var $win = $(window);
    var winH = $win.height(),
      h;
    if (winH < $main.height()) {
      h = 0;
    } else {
      h = (winH - $main.height()) / 2;
    }
    if (top > 0) {
      winH += top;
    }
    if (!-[1]) {
      mask.style.height = winH + "px";
    }
    $main.css({
      marginTop: h + "px"
    });
  },

  /**
   * 动态创建html
   * @param Object jsonList
   * {eventOk:function(){}}
   */
  outSideCreateHtml: function (jsonList) {

    var _self = this,
      _cache = _self.cache,
      _config = _self.config;
    if (_config.isInitReset && document.getElementById("selection-mask") != null) {
      $("#selection-mask").remove();
    } else {
      if (document.getElementById("selection-mask") != null) {
        $("#selection-mask").css("top", $("body").scrollTop() + "px");
        $("#selection-mask").show();
        return;
      }
    }
    var mask = document.createElement("div");
    if (jsonList.isMask) {
      mask.className = "selection-mask";
      mask.style.top = $("body").scrollTop() + "px";
    }
    mask.id = "selection-mask";
    var main = document.createElement("div");
    main.className = "selection-main";
    main.id = _config.id;
    var head, options = _config.options;

    var title = document.createElement("div");
    title.className = "selection-title";
    head = '<ul id="indicator_tabs" class="nav nav-tabs" role="tablist">';
    //加载tab
    for (var i = 0, len = options.length, isActive; i < len; i++) {
      isActive = i == 0 ? 'class="active"' : "";
      head += '<li role="presentation" ' + isActive + '>\
          					<a href="#' + options[i].name + '" id="' + options[i].name + '-tab" role="tab" data-toggle="tab" aria-controls="' + options[i].name + '" aria-expanded="true">' + options[i].show + '</a>\
      					</li>';
    }
    if (_config.isSelectReturnData) {
      head += "<li style='margin-left:50px;padding-top:4px'><span style='padding-right:5px;'><input type='radio' class='radio-input' checked name='returnType' value='1'/>全部数据</span><span><input type='radio' class='radio-input' name='returnType' value='0'/>当前数据</span></li>";
    }
    head += "</ul>";
    title.innerHTML = head;
    var closed = document.createElement("a");
    closed.className = "selection-close";
    closed.setAttribute("href", "javascript:;");
    closed.innerHTML = "×";
    closed.onclick = function () {
      //关闭事件
      _self.closed();
    };
    title.appendChild(closed);
    main.appendChild(title);

    var content = document.createElement("div");
    content.className = "selection-content tab-content";


    for (var i = 0, len = options.length, isActive; i < len; i++) {
      isActive = i == 0 ? 'active' : "";
      var tabsContain = document.createElement("div"),
        list = document.createElement("div"),
        toolbar = document.createElement("div");

      tabsContain.className = "tab-pane " + isActive;
      tabsContain.id = options[i].name;

      toolbar.className = "selection-toolbar";
      list.className = "selection-content-list";

      if (_config.isExcelBtn) { //在excel自定义报表中 添加三个特殊按钮
        var horizontalButton = document.createElement("span"),
          verticalButton = document.createElement("span");


        horizontalButton.className = "selection-btn btn-gray";
        horizontalButton.id = "horizontal-" + options[i].name
        verticalButton.className = "selection-btn btn-gray _mgl mgl";
        verticalButton.id = "vertical-" + options[i].name

        horizontalButton.innerHTML = "横向";
        verticalButton.innerHTML = "竖向";

        horizontalButton.onclick = function () {
          if ($(this).hasClass("current")) { //取消选中
            $(this).removeClass("current");
          } else { //选中
            $(this).addClass("current");
            $(this).next().removeClass("current");
          }
        }
        verticalButton.onclick = function () {
          if ($(this).hasClass("current")) { //取消选中
            $(this).removeClass("current");
          } else { //选中
            $(this).addClass("current");
            $(this).prev().removeClass("current");
          }
        }
        toolbar.appendChild(horizontalButton);
        toolbar.appendChild(verticalButton);


        var p1 = document.createElement("div");
        p1.className = "selection-header";
        var inputSearch = document.createElement("input");
        inputSearch.className = "selection-current selection-search";
        inputSearch.type = "text";
        inputSearch.name = "title";
        inputSearch.value = "请输入关键字";
        inputSearch.onfocus = function () {
          if (this.value == "请输入关键字") {
            this.value = "";
          }
        };
        inputSearch.onblur = function () {
          if (this.value == "") {
            this.value = "请输入关键字";
          }
        };
        var btnSearch = document.createElement("span");
        btnSearch.className = "search-btn btn-gray";
        btnSearch.innerHTML = "搜索";
        //实时搜索
        $(btnSearch).bind("click", function () {
          _self.keyupSearch(_cache.jsonList, this.previousSibling);
        })
        p1.appendChild(inputSearch);
        p1.appendChild(btnSearch);
        var p10 = document.createElement("div");
        p10.className = "selection-wrap";
        if (options[i].name == 'group') { //分组加上有允许多选
          var multiButton = document.createElement("span");
          multiButton.className = "selection-btn btn-gray mgl";
          multiButton.id = "button-multi-" + options[i].name;
          multiButton.innerHTML = "交叉分组";
          multiButton.setAttribute("multi", false);
          multiButton.onclick = function () { //绑定多选按钮的点击时间
            if ($(this).hasClass("current")) { //单击为单选的时候
              $(this).removeClass("current");
              this.setAttribute("multi", false);
              document.getElementById("selection-content-current-group").innerHTML = "";
              $('#superposition-group').hide().removeClass('current');
            } else { //单击为多选的时候
              $(this).addClass("current");
              this.setAttribute("multi", true);
              document.getElementById("selection-content-current-group").innerHTML = "";
              $('#superposition-group').show().removeClass('current');
            }
          }
          var superposition = document.createElement('span');
          superposition.className = 'selection-btn btn-gray ';
          superposition.id = "superposition-" + options[i].name;
          superposition.innerHTML = "交叉叠加";
          superposition.style.display = 'none';
          superposition.onclick = function () {
            $(this)[$(this).hasClass('current') ? 'removeClass' : 'addClass']('current');
          }
          toolbar.appendChild(multiButton);
          toolbar.appendChild(superposition);
        }
        var data = document.createElement("ul");
        data.className = "ztree";
        data.id = "selection-data-" + options[i].name;
        list.appendChild(p1);
        p10.appendChild(data);
        list.appendChild(p10);

      }
      if (!!options[i].redirect) { //&& g_admin=="1"
        var redirectButton = document.createElement("a");
        redirectButton.className = "selection-btn btn-gray";
        redirectButton.id = "redirect-" + options[i].name
        redirectButton.href = options[i].redirect;
        redirectButton.target = "_blank";
        redirectButton.innerHTML = "管理";

        toolbar.appendChild(redirectButton);
      }
      var current = document.createElement("div");
      current.className = "selection-content-current";
      var currentH3 = document.createElement("div");
      currentH3.className = "selection-header";
      var clearCurrent = document.createElement("span");
      clearCurrent.className = "selection-btn  btn-gray pull-right";

      clearCurrent.innerHTML = "清空全部";
      clearCurrent.onclick = function () {
        _self.delAll();
      };
      currentH3.appendChild(clearCurrent);
      currentH3.appendChild(document.createTextNode("已选择(单击取消)："));
      current.appendChild(currentH3);
      var currentUl = document.createElement("ul");
      currentUl.id = "selection-content-current-" + options[i].name;
      current.appendChild(currentUl);
      if (options[i].name == 'indExplain') {
        tabsContain.innerHTML = '<textarea style="width: 100%; height: 350px; max-height: 90%;"></textarea>';
      } else {
        tabsContain.appendChild(toolbar);
        tabsContain.appendChild(list);
        tabsContain.appendChild(current);
      }

      content.appendChild(tabsContain);
    }

    var handle = document.createElement("div");
    handle.className = "selection-handle";
    var btnConfirm = document.createElement("input");
    btnConfirm.type = "button";
    btnConfirm.value = "确 定";
    btnConfirm.className = "selection-btn selection-btn-confirm";
    btnConfirm.onclick = function () {
      if (_config.isPopWindow) {
        //确认提交
        _self.successDialog(jsonList);
      } else {
        _self.success(jsonList);
      }
    };
    var span = document.createElement("span");
    var btnCancel = document.createElement("input");
    btnCancel.type = "button";
    btnCancel.value = "取 消";
    btnCancel.className = "selection-btn selection-btn-cancel";
    btnCancel.onclick = function () {
      _self.closed();
    };
    handle.appendChild(btnConfirm);
    handle.appendChild(span);
    handle.appendChild(btnCancel);
    main.appendChild(content);
    main.appendChild(handle);
    mask.appendChild(main);
    document.body.appendChild(mask);

    //弹出层居中显示
    _self.showLoadingStatus();
    ///获取数据
    //$(document)'#'+_self.config.id
    $('body').off("click.matrix.multiselect").on("click.matrix.multiselect", "[data-toggle='tab']", function () {
      var selId = !!$(this).attr("id") && $(this).attr("id").split("-")[0];
      if ($("ul#selection-data-" + selId + " li").length) {
        return;
      }
      _self.initTree("selection-data-" + selId, _config.urls[selId]);
    })
    _self.initTree("selection-data-indicator", _config.urls["indicator"]);
    _self.dragSelectData();
    _self.deleteNode();
    _self.clickRadiobox();
    //		_self.autoCompleteSearch();
  },
  /**
   * 绑定单选款的单击事件
   */
  clickRadiobox: function () {
    var _self = this,
      _config = _self.config,
      _cache = _self.cache;
    $("input.radio-input").on("click", function () {
      _config.isReturnAllData = !!~~$(this).val();
    })
  },
  /**
   * 删除选中的节点
   */
  deleteNode: function () {
    $("body").on("click", "span.glyphicon-remove", function (e) {
      $(this).parent().remove();
    })
  },
  /**
   * 拖动选择的指标数据
   */
  dragSelectData: function () {
    var dx, dy, isMove = false,
      height, movedNode, num;
    $("body").on("mousedown", "div.selection-content-current ul li a", function (e) {
      e.preventDefault();
      var $this = $(this).parent(),
        dx = e.pageX,
        dy = e.pageY,
        movedNode = $this.clone();
      isMove = true;
      height = 24 * ($this.index())
      $this.on("mousemove", function (e) {
        if (isMove) {
          $this.css({
            "position": "absolute",
            "z-index": 999
          });
          $this.find("a").css({
            "cursor": "move"
          });
          $this.css({
            top: height + e.pageY - dy
          })
        }
      }).on("mouseup", function (e) {
        num = Math.ceil(parseInt($this.css("top")) / 24);
        var parentNode = $this.parent();
        if (!!parentNode.find("li:eq(" + num + ")").length) {
          $(movedNode).insertBefore(parentNode.find("li:eq(" + num + ")"));
        } else {
          parentNode.append(movedNode);
        }
        $this.remove();
        isMove = false
      })
    })
  },
  /**
   * 返回ajax数据
   * @param  {String} url
   */
  ajaxReturnJsonList: function (url, data) {
    var json = "";
    $.ajax({
      url: url,
      type: "get",
      cache: true,
      headers: {
        'userId':window.localStorage.userId,
        'sessionId':window.localStorage.sessionId,
        'token':window.localStorage.token
      },
      dataType: "json",
      data: data,
      async: false,
      success: function (jsonList) {
        json = jsonList;
      }
    });
    return json
  },
  /**
   * 自动输入搜索
   */
  autoCompleteSearch: function () {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config,
      $input = $(".selection-main .selection-search"),
      timeCount;
    $input.on("input propertychange", function (e) { //定时检测输入 500毫秒未输入则进行数据查找操作
      clearTimeout(timeCount);
      var that = this;
      timeCount = setTimeout(function () {
        var search = that.value;
        !!search ? (function () {
          _self.keyupSearch(_cache.jsonList, that);
        })() : "";
      }, 500)
    });
    $input.on("click", function (e) { //绑定单击input框事件
      var search = $(this).val(),
        that = this;
      !!search ? (function () {
        _self.keyupSearch(_cache.jsonList, that);
      })() : "";
    })
  },
  /**
   * 获取数据，必对其进行相应的处理
   * @param {Object} json
   */
  accessDataSource: function (json) {
    var _self = this,
      _config = _self.config,
      _cache = _self.cache;
    _cache.jsonList = json;
    for (var i = 0; i < json.length; i++) {
      if (json[i].isDir == 1) { //把目录和数据区分开来。方便搜索功能
        _cache.jsonType.push(json[i]);
      } else if (json[i].isDir == 0) {
        _cache.jsonData.push(json[i]);
      }
    }
  },
  /**
   * 搜索事件,搜索json数据下所有的信息，通过所传数组中的条件字段，进行模糊查询。支持配置多个字段。
   * @param {Array} arr
   * @param {Object} _this
   */
  keyupSearch: function (arr, _this, input) {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config,
      sid = _self.getSelectTabId(),
      value = _this.value,
      data = document.getElementById("selection-data-" + sid),
      current = document.getElementById("selection-content-current-" + sid).getElementsByTagName("a");
    if (_this.value === "" || _this.value === "请输入关键字") { //当搜索框值清空时 直接搜索原来数据
      var json = _self.ajaxReturnJsonList(_config.urls[sid], {
        "label": '' 
      });
      _self.initTree("selection-data-" + sid, _config.urls[sid], json);
      if (input == 'inputSearch2') {
        _self.initTree("selection-data-" + sid + '2', 'indiDef-selectDepartmentIndicators.action', json);
      } else {
        _self.initTree("selection-data-" + sid, _config.urls[sid])
      }
    } else {
      var json = _self.ajaxReturnJsonList(_config.urls[sid], {
        "label": _this.value
      });
      _self.initTree("selection-data-" + sid, _config.urls[sid], json);
    }
  },
  /**
   * 添加选择项事件，支持单个和多个选项添加，并且选择项长度为0时，灰色，选择项长度大于0时，高量并绑定事件。
   * @param {Object} _this
   */
  add: function (_this) {
    var _self = this,
      _cache = _self.cache,
      sid = _self.getSelectTabId(),
      node = document.getElementById(_this.id) //点击的a节点;

    //选中区域的数据展示处理
    var current = document.getElementById("selection-content-current-" + sid);
    var li = document.createElement("li"),
      spanTitle = document.createElement("span"),
      spanUnit = document.createElement("span"),
      deleteNode = document.createElement("span"),
      a = document.createElement("a");
    spanTitle.innerHTML = _this.name;
    spanUnit.className = "unit";
    deleteNode.className = "glyphicon glyphicon-remove";
    if (sid === 'group') {
      a.id = _this.grouptypeid + "_" + _this.id;
    } else {
      if(_this.hasOwnProperty('regimeType')){
        a.id = `${_this.regimeType}:${_this.id}`;
      }else{
        a.id = _this.id;
      }
    }
    a.setAttribute("href", "javascript:;");
    if (sid === 'indicator') {
      var unitid = ((_this.unitId == undefined) ? _this.unit_id : _this.unitId)
      var unitName = ((_this.unitName == undefined) ? _this.unit_name : _this.unitName)
      a.setAttribute('unitid', unitid);
      spanUnit.innerHTML = "(" + unitName  +")";
    }
    a.ondblclick = function () { //点击删除事件
      _self.del(this);
    };
    a.appendChild(spanTitle);
    a.appendChild(spanUnit);
    li.appendChild(a);
    // if(sid==='indicator'){//如果是指标 则有单位可以选择
    // 	var span=document.createElement("span");//下拉框
    // 	span.className="inlineBlock backimg up";
    // 	li.appendChild(span);			
    // }
    li.appendChild(deleteNode);
    current.appendChild(li);
  },
  /**
   * 删除全部已选择
   */
  delAll: function () {
    var _self = this,
      _cache = _self.cache,
      sid = _self.getSelectTabId();
    var current = document.getElementById("selection-content-current-" + sid).getElementsByTagName("a");
    var len = current.length;
    for (var i = 0; i < len; i++) {
      this.del(current[0]);
    }
  },
  /**
   * 删除选择项事件，支持单个和多个选项删除，并且选择项长度为0时，灰色，选择项长度大于0时，高量并绑定事件。
   * @param {Object} _this
   */
  del: function (_this) {
    var _self = this,
      _cache = _self.cache,
      sid = _self.getSelectTabId();
    $(_this).parent().remove();
  },
  /**
   * 确认提交事件，当已选择的长度为0时，确认按钮显示灰色。大于0时，高度显示并绑定事件。
   */
  success: function (jsonList) {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config;
    var json = _self.getSelectedCollection();
    $("div#" + _config.id).data(json);
    if (_config.isReturnAllData) {
      var warningMsg = [];
      for (var i = 0, len = _config.isValidateSelect.length; i < len; i++) {
        if (json[i].val.length === 0 && !!_config.isValidateSelect[i]) {
          warningMsg.push(_config.options[i].show);
        }
      }
      if (!!warningMsg.length) {
        alert(warningMsg.join(",") + "不能为空!");
        return;
      }
    }
    if (typeof jsonList.eventOk != 'undefined' & jsonList.eventOk instanceof Function) {
      var list = jsonList.eventOk(json);
    }
    _self.closed();
  },
  successDialog: function (jsonList) {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config;
    var json = _self.getSelectedCollection();
    var len = json.length;
    var arrID = [],
      arrName = [];
    var returnValue = [];
    for (var i = 0; i < len; i++) {
      arrID.push('\'' + json[i].id + '\'');
      arrName.push(json[i].name);
    }


    returnValue.push(arrID);
    returnValue.push(arrName);
    window.returnValue = returnValue;
    window.close();
    //document.getElementById(_config.selectedID).value=arrID.join(",");
    //document.getElementById(_config.outSideID).value=arrName.join(",");
    //用户自定义方法处理
    /*if(typeof jsonList.eventOk!='undefined'&jsonList.eventOk instanceof Function){
    	var list=jsonList.eventOk();
    }*/
  },
  /**
   * 关闭筛选事件
   */
  closed: function () {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config,
      sid = _self.getSelectTabId();
    if (_config.isPopWindow) {
      window.close();
    } else {
      document.getElementById("selection-mask").style.display = "none";
    }
  },
  //点击确定按钮 获取选择的参数列表
  getSelectedCollection: function () {
    var _self = this,
      _config = _self.config;
    var arr = [];
    for (var i = 0, len = _config.options.length, current, j; i < len; i++) {
      if (!_config.isReturnAllData && document.getElementById(_config.options[i].name).className.indexOf("active") == -1) { //没有选中 且为只填充选中tab的数据
        continue;
      }
      var vals = [],
        obj = {};
      if (_config.options[i].name != 'indExplain') {
        current = document.getElementById("selection-content-current-" + _config.options[i].name).getElementsByTagName("a");

        for (j = 0; j < current.length; j++) {
          var param = {};
          if (_config.options[i].name === 'indicator') {
            param.id = current[j].id;
            param.name = $(current[j]).text();
            param.unitid = current[j].getAttribute("unitid");
            param.unitname = $(current[j]).find(".unit").text().replace("(", "").replace(")", "");
          } else if (_config.options[i].name === 'group') {
            param.id = current[j].id.split('_')[1];
            param.name = $(current[j]).text();
            param.grouptypeid = current[j].id.split('_')[0];
          } else {
            param.id = current[j].id;
            param.name = $(current[j]).text();
          }
          vals.push(param);
        }
      } else {
        vals.push({
          name: $('#indExplain').find('textarea').val()
        })
      }
      obj["type"] = _config.options[i].name;
      obj["val"] = vals;
      if (!!_config.isExcelBtn) { //如果使用在excel里面 则添加特殊处理判断
        if ($("#horizontal-" + _config.options[i].name).hasClass("current")) {
          obj["orientation"] = "horizontal";
        } else if ($("#vertical-" + _config.options[i].name).hasClass("current")) {
          obj["orientation"] = "vertical";
        } else {
          obj["orientation"] = "";
        }
        if ($("#title-" + _config.options[i].name).length) {
          obj["title"] = $("#title-" + _config.options[i].name).hasClass("current") ? true : false;
        }
      }
      if (!!_config.isMultiBtn && !!$("#button-multi-" + _config.options[i].name).length) {
        obj["multi"] = $("#button-multi-" + _config.options[i].name).attr("multi") === 'false' ? false : true;
      }
      if (obj['multi']) { //叠加
        if ($('#superposition-' + _config.options[i].name).hasClass('current')) {
          obj["superposition"] = true;
        }
      }
      arr.push(obj);
    }
    return arr;
  },
  //单位下拉组件
  unitDropDown: function (json, node) {
    var div = document.createElement("div"),
      p,
      result = json.data;
    div.className = "unitlist";
    for (var i = 0, len = result.length; i < len; i++) {
      p = document.createElement("p");
      p.setAttribute("unitid", result[i].unitId);
      p.innerHTML = result[i].unitName;
      p.onmouseover = function () {
        this.style.backgroundColor = "#c6e8f4";
      }
      p.onmouseout = function () {
        this.style.backgroundColor = "";
      }
      div.appendChild(p);
    }
    $("#selection-content-current-indicator").off("click.indicator.unit.unit").on("click.indicator.unit.unit", ".unitlist p", function () {
      var unitid = this.getAttribute("unitid");
      $(".unitlist p.selected").removeClass("selected");
      this.className = "selected";
      this.parentNode.parentNode.getElementsByTagName("a")[0].setAttribute("unitid", unitid);
      this.parentNode.style.display = "none";
      $(this).parent().parent().find(".unit").text("(" + $(this).text() + ")");
    })
    node.appendChild(div);
  },
  //是否可多选判断
  isMulti: function () {
    var isMulti = $("#button-multi-" + this.getSelectTabId()).attr("multi")
    return isMulti === "true" ? true : false;
  },
  //是否已选择指标项判断
  isSelecionPanelHasNode: function () {
    return !!$("#selection-content-current-" + this.getSelectTabId()).children("li").length;
  },
  //获取目前选择的tab
  getSelectTabId: function () {
    var _self = this,
      _config = _self.config;
    return $("div#" + _config.id + " ul.nav-tabs li.active a").attr("id").split("-")[0];
  },
  //初始化树配置
  initTreeSetting: function (url) {
    var _self = this,
      _config = _self.config,
      sid = _self.getSelectTabId();
    //设置view
    if (typeof (url) == 'undefined') {
      return;
    }
    var view = {
      selectedMulti: false
    };
    //地区树配置
    var setting = {
      async: {
        type: 'get',
        enable: true,
        url: url,
        autoParam: ["id", "name=n", "level=lv"],
        otherParam: {},
        headers: {
          'userId':window.localStorage.userId,
          'sessionId':window.localStorage.sessionId,
          'token':window.localStorage.token
        },
        dataFilter: function (treeId, parentNode, childNodes) {
          if (!childNodes) return null;
          var Nodes
          if(treeId == 'selection-data-indicator'){
            if(desingVm.$route.path == '/Index/booklets/reportManage'){
              Nodes = childNodes.data.data
              for (var i = 0, l = Nodes.length; i < l; i++) {
                if(!Nodes[i].hasOwnProperty('unit_id'))
                Nodes[i].isParent = true
              }
            }else{
              Nodes = childNodes;
            }
          }else{
            Nodes = childNodes;
          }
          for (var i = 0, l = Nodes.length; i < l; i++) {
            Nodes[i].name = Nodes[i].name.replace(/\.n/g, '.');
          }
          return Nodes;
        }
      },
      view: view,
      data: {
        simpleData: {
          enable: true,
        }
      },
      callback: {
        beforeClick: function (treeId, treeNode, clickFlag) {
          if (_self.isSelect(treeNode.id) || _self.isSelect(treeNode.grouptypeid + "_" + treeNode.id)) { //选择过的不能选
            return false;
          }
          if (sid === "group") { //分组能选则不同分类下
            if (_config.isMultiBtn && treeNode.level > 1 && $("#button-multi-group").attr("multi") === "false" && !_self.isSelect(treeNode.grouptypeid + "_" + treeNode.id)) {
              return true;
            } else if (_self.isSelect(treeNode.grouptypeid)) {
              return false;
            } else if (treeNode.level > 1 && $("#superposition-group").hasClass('current')) {
              return true;
            } else if (treeNode.level > 1 && _self.selectedNum() < 3) { //第二层开始能选，且只能选三个
              return true;
            }
            return false;
          } else if (sid === "indicator") { //指标只能选子节点
            if (!treeNode.isParent && !_self.isSelecionPanelHasNode() && !_self.isMulti()) {
              return true;
            } else if (!treeNode.isParent && _config.isMultiBtn) {
              return true;
            } else {
              return false;
            }
          } else if (sid === "area") { //地区所有可选
            if (treeNode.level > 0 && !_self.isSelecionPanelHasNode() && !_self.isMulti()) {
              return true;
            } else if (treeNode.level > 0 && _config.isMultiBtn) {
              return true;
            } else {
              return false;
            }
          } else if (sid === "contrast") {
            if (!_self.isSelecionPanelHasNode()) {
              return true;
            } else if (_config.isMultiBtn) {
              return true;
            } else {
              return false;
            }
          }
        },
        onClick: function (event, treeId, treeNode) {
          _self.add(treeNode);
        },
        onAsyncSuccess: function (event, treeId, treeNode) {
          if (treeId == 'selection-data-indicator2') { //按表样选择指标，默认展开第一层节点
            if (typeof (treeNode) == 'undefined') { //当搜索后，默认展开第一层节点
              var tree = $.fn.zTree.getZTreeObj(treeId);
              var nodes = tree.getNodes();
              if (nodes != null && nodes.length > 0)
                tree.expandNode(nodes[0], true, false, true);
            }
            $('#inputSearch2').focus();
          }
        }
      }
    }
    if (sid === 'group') {
      setting.async.autoParam.length = 0;
      setting.async.autoParam = ["id", "grouptypeid", "fatherid", "name=n", "level=lv"];
    } else {
      setting.async.autoParam.length = 0;
      setting.async.autoParam = ["id", "name=n", "level=lv"];
    }
    return setting;
  },
  //初始化树结构
  initTree: function (id, url, json) {
    json ? $.fn.zTree.init($("#" + id), this.initTreeSetting(url), json) : $.fn.zTree.init($("#" + id), this.initTreeSetting(url));
  },
  //是否已被选择的判断
  isSelect: function (id) {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config,
      sid = _self.getSelectTabId();
    if ($("#selection-content-current-" + sid + " li a[id='" + id + "']").length > 0) {
      return true;
    }
    if (sid === "group") {
      if (!$("#button-multi-group").attr("multi") || $("#button-multi-group").attr("multi") === "true") {
        if ($("#selection-content-current-" + sid + " li a[id^='" + id + "']").length > 0) {
          return true;
        }
      }
    }
    return false;
  },
  //返回已经选择的指标个数
  selectedNum: function () {
    var _self = this,
      _cache = _self.cache,
      _config = _self.config,
      sid = _self.getSelectTabId();
    return $("#selection-content-current-" + sid + " li a").length;
  }
};


+
function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    this.element = $(element)
  }

  Tab.VERSION = '3.3.2'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this = this.element
    var $ul = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active = container.find('> .active')
    var transition = callback &&
      $.support.transition &&
      (($active.length && $active.hasClass('fade')) || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu')) {
        element
          .closest('li.dropdown')
          .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
      .one('bsTransitionEnd', next)
      .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $('body')
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)



}(jQuery);


/**
 * 按表样选指标，选中后父页面函数操作
 */

export {
  panelselection
}



//////////////////
// WEBPACK FOOTER
// ./static/handsontable/js/muiltSelectForEditor.js
// module id = jqsD
// module chunks = 1